			
import React from "react";
import Icon from "../icon.js";

function Glasses(props) {
	return(

		<Icon {...props}>
			<path d="M17.945 8c-1.138 0-2.377.129-3.395.491-2.283.828-2.791.838-5.102 0-1.016-.362-2.256-.491-3.393-.491-1.971 0-4.169.387-6.055.878v1.789c.848.255 1.068.627 1.203 1.493.381 2.443 1.256 4.84 5.069 4.84 3.036 0 4.051-2.259 4.722-4.345.34-1.06 1.662-1.087 2.008-.015.674 2.089 1.682 4.36 4.726 4.36 3.813 0 4.688-2.397 5.069-4.841.135-.866.355-1.237 1.203-1.493v-1.788c-1.886-.491-4.084-.878-6.055-.878zm-7.683 3.814c-.518 2.174-1.36 4.186-3.99 4.186-3.301 0-3.974-1.903-4.275-4.973-.073-.747.091-1.04.22-1.195.948-1.134 5.953-1.088 7.611-.092.476.285.784.601.434 2.074zm11.741-.787c-.302 3.07-.975 4.973-4.275 4.973-2.63 0-3.472-2.012-3.989-4.186-.351-1.473-.042-1.789.434-2.074 1.664-1 6.667-1.038 7.611.092.128.156.292.449.219 1.195zm-4.839-1.121c1.539-.234 3.318-.03 3.791.537.104.124.235.358.177.956-.031.316-.067.616-.112.9-.411-1.487-1.458-2.283-3.856-2.393zm-14.184 2.393c-.045-.284-.081-.584-.112-.9-.059-.597.073-.832.177-.956.473-.567 2.252-.771 3.791-.537-2.398.11-3.445.906-3.856 2.393z"/>
		</Icon>

	)
}

export default  Glasses;
